// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2TwfE","obliqueLineWrap":"membershipbadge_obliqueLineWrap__37HGx","obliqueLine":"membershipbadge_obliqueLine__1Hwn9"};